import { useCallback, useContext } from 'react';

import LoggedInUserContext from '../../context/LoggedInUserContext';
import AnnouncementContext from '../context/AnnouncementContext';
import Community from '../Model/Community';

export const CommunityCreationStatus = {
  CREATED: 'created',
  NAME_TAKEN: 'nameTaken',
  INVALID: 'invalid',
  ERROR: 'error',
};

/**
 * Shared community-creation flow used by CommunitySelect and CommunityFormModal: sources createdBy,
 * checks name uniqueness, and creates the community. Returns a { status, id?, message? } result
 * (see CommunityCreationStatus) so each caller shows its own message.
 */
const useCommunityCreation = (coachId) => {
  const { userId: createdBy } = useContext(LoggedInUserContext);
  const { isCommunityNameTaken } = useContext(AnnouncementContext);

  const createCommunity = useCallback(async ({ name, customTags = [], excludeId = null }) => {
    const trimmedName = (name || '').trim();
    if (!trimmedName || !coachId) {
      return { status: CommunityCreationStatus.INVALID };
    }
    if (isCommunityNameTaken(trimmedName, excludeId)) {
      return { status: CommunityCreationStatus.NAME_TAKEN };
    }
    try {
      const id = await Community.createCommunity({
        coachId,
        name: trimmedName,
        createdBy,
        customTags,
      });
      return { status: CommunityCreationStatus.CREATED, id };
    } catch (error) {
      return { status: CommunityCreationStatus.ERROR, message: error.message };
    }
  }, [coachId, createdBy, isCommunityNameTaken]);

  return { createCommunity, isCommunityNameTaken };
};

export default useCommunityCreation;
